import { useQuery } from '@tanstack/react-query';
import api from '../services';

export const useCapConfiguration = (entityId, isOfferAction, enabled = true) => {
  const endpoint = isOfferAction ? 'offer-action' : 'offers';
  return useQuery({
    queryKey: ['capConfiguration', entityId, isOfferAction],
    queryFn: async () => {
      const response = await api.get(`${endpoint}/current-cap-amount/cap-configuration/${entityId}`);
      return response.data;
    },
    enabled: enabled && !!entityId,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
